export default {
  tinymceHtml: "",
};
